import { useMemo, useState, useEffect } from 'react';

const useMediaQuery = (props) => {
    // 1. Memoize the query string for performance and type safety.
    const query = useMemo(() => {
        const { queryType } = props;
        switch (queryType) {
            case "max-width":
            case "min-width":
            case "max-height":
            case "min-height":
                // Safely access sizePx only for custom query types
                return `(${queryType}: ${props.sizePx}px)`;
            case "mobile":
                return `(max-width: 576px)`;
            case "medium-screen":
                return `(max-width: 991px)`;
            case "desktop":
                return `(min-width: 992px)`;
            default:
                return "";
        }
    }, [props]); // Recalculate only when props change.
    // 2. Safely initialize state, considering Server-Side Rendering (SSR).
    const [matches, setMatches] = useState(() => {
        var _a;
        if (typeof window !== "undefined") {
            return window.matchMedia(query).matches;
        }
        // Fallback for SSR and initial state
        return (_a = props.initialState) !== null && _a !== void 0 ? _a : false;
    });
    // 3. Use an efficient listener and fix the dependency array.
    useEffect(() => {
        // Ensure this effect runs only on the client.
        if (typeof window === "undefined")
            return;
        const mediaQueryList = window.matchMedia(query);
        const listener = (event) => {
            setMatches(event.matches);
        };
        // The 'change' event is more efficient than 'resize'.
        mediaQueryList.addEventListener("change", listener);
        // Cleanup listener on component unmount.
        return () => {
            mediaQueryList.removeEventListener("change", listener);
        };
    }, [query]); // <- The dependency array is now correct.
    return matches;
};

export { useMediaQuery as default };
//# sourceMappingURL=useMediaQuery.js.map
